import { render, staticRenderFns } from "./CategoriaTabela.vue?vue&type=template&id=015360aa&lang=html"
import script from "./CategoriaTabela.vue?vue&type=script&lang=js"
export * from "./CategoriaTabela.vue?vue&type=script&lang=js"
import style0 from "./CategoriaTabela.vue?vue&type=style&index=0&id=015360aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports